export const num2name = {
    0: "ERROR_UNSPECIFIED",
};
export const name2num = {
    ERROR_UNSPECIFIED: 0,
};
